import React, { useState, useEffect } from 'react';
import * as _ from 'lodash';
import moment from 'moment';
import Styles from './CMDashboard.module.css';
import { setApplicantionInfo } from '../../common/utils/applicantionInfo';
import AssignCM from './AssignCM';
import { getAcl } from '../../common/utils/acl-utils';

const { whiteSpacePreLine } = Styles;

const commonStyle = 'font-khand font-normal text-sm text-black-500 mx-auto';
const commonRowStyle = `font-roboto font-normal text-xs text-black-850 mx-auto ${whiteSpacePreLine}`;
export const numberFormat = number => {
  if (!isNaN(number) && number) {
    let num;
    try {
      num = number
        .toFixed(1)
        .replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,')
        .toString()
        .split('.')[0];
    } catch {
      num = number;
    }
    return num;
  }
  return number;
};
const openDetailView = (setDetailView, leadId, status, loanAmount) => {
  let applicationInfo = {
    leadId: leadId,
    leadApplicantId: false,
    applicationStatus: status,
    loanAmount: loanAmount
  };
  setApplicantionInfo(applicationInfo);
  setDetailView(true);

  localStorage.hasOwnProperty('salary-slips')
    ? localStorage.removeItem('salary-slips')
    : null;
  localStorage.hasOwnProperty('bank-statements')
    ? localStorage.removeItem('bank-statements')
    : null;
  localStorage.hasOwnProperty('form-16')
    ? localStorage.removeItem('form-16')
    : null;
  localStorage.hasOwnProperty('ITR') ? localStorage.removeItem('ITR') : null;
};

const getTime = time => {
  let total_minutes,
    no_of_days,
    dir = ' Left',
    hours;
  total_minutes = parseFloat(moment(time).diff(moment(), 'minutes'));
  if (total_minutes < 0) {
    dir = ' Exceeded';
    total_minutes = Math.abs(total_minutes);
  }
  if (total_minutes > 1440) {
    no_of_days = parseInt(total_minutes / 1440);
    hours = parseInt((total_minutes - no_of_days * 1440) / 60);
    return `${no_of_days} days ${hours} hours ${dir}`.toString();
  }
  if (total_minutes < 60) {
    return `${total_minutes} minutes ${dir}`.toString();
  } else {
    return `${parseInt(total_minutes / 60)} hours ${dir}`.toString();
  }
};

const ShowAssignModal = ({ row, setCMName, setShowReassign, showCMName }) => {
  let firstName = '',
    middleName = '',
    lastName = '';
  if (typeof row?.cmName?.firstName == 'string')
    firstName = row.cmName.firstName;
  if (typeof row?.cmName?.middleName == 'string')
    middleName = row.cmName.middleName;
  if (typeof row?.cmName?.lastName == 'string') lastName = row.cmName.lastName;
  return (
    <AssignCM
      leadId={row?.leadId}
      row={row}
      CMName={`${showCMName}`}
      setCMName={setCMName}
      setShowReassign={setShowReassign}
    />
  );
};

const CMColumn = setDetailView => [
  {
    name: <span className={`${commonStyle}`}>Lead ID</span>,
    selector: 'leadId',
    sortable: true,
    cell: row => <div className={`${commonRowStyle}`}>{row.leadId}</div>
  },
  {
    name: <span className={`${commonStyle}`}>Lead Name</span>,
    selector: 'leadName',
    sortable: true,
    cell: row => {
      let firstName = '',
        middleName = '',
        lastName = '';
      if (_.get(row, 'leadName.firstName', false))
        firstName = _.get(row, 'leadName.firstName', '');
      if (_.get(row, 'leadName.middleName', false))
        middleName = _.get(row, 'leadName.middleName', '');
      if (_.get(row, 'leadName.lastName', false))
        lastName = _.get(row, 'leadName.lastName', '');

      return (
        <div className={`${commonRowStyle}`}>
          {`${firstName} ${middleName} ${lastName}`}
        </div>
      );
    },
    minWidth: '150px !important'
  },
  {
    name: <span className={`${commonStyle}`}>Phone Number</span>,
    selector: 'phone',
    sortable: true,
    cell: row => (
      <div className={`${commonRowStyle}`}>{row.phone ? row.phone : '---'}</div>
    )
  },
  {
    name: <span className={`${commonStyle}`}>Product Type</span>,
    selector: 'productType',
    sortable: true,
    cell: row => (
      <div className={`${commonRowStyle}`}>
        {row.productType ? row.productType : '---'}
      </div>
    )
  },
  {
    name: <span className={`${commonStyle}`}>Sub Product Type</span>,
    selector: 'subProduct',
    sortable: true,
    cell: row => (
      <div className={`${commonRowStyle}`}>
        {row.subProduct ? row.subProduct : '---'}
      </div>
    )
  },
  {
    name: (
      <span className={`${commonStyle}  text-right mr-0 `}>Loan Amount</span>
    ),
    selector: 'loanAmount',
    sortable: true,
    cell: row => (
      <div className={`${commonRowStyle} w-48 text-right mr-0 `}>
        {row.loanAmount ? (
          <span> &#8377;{` ${numberFormat(row.loanAmount)}`} </span>
        ) : (
          '---'
        )}
      </div>
    )
  },
  {
    name: <span className={`${commonStyle}`}>Bank</span>,
    selector: 'bankName',
    sortable: true,
    cell: row => (
      <div className={`${commonRowStyle}`}>{row.bankName || '---'}</div>
    )
  },
  {
    name: <span className={`${commonStyle}`}>Login Date</span>,
    selector: 'loginDate',
    sortable: true,
    cell: row => (
      <div className={`${commonRowStyle}`}>
        {row.loginDate ? moment(row.loginDate).format('DD-MM-YYYY') : '---'}
      </div>
    )
  },

  {
    name: <span className={`${commonStyle}`}>Target Month</span>,
    selector: 'leadTargetMonth',
    sortable: true,
    cell: row => (
      <div className={`${commonRowStyle}`}>
        {row.leadTargetMonth
          ? moment(row.leadTargetMonth).format('MMM-YYYY')
          : '---'}
      </div>
    )
  },

  {
    name: <span className={`${commonStyle}`}>Submitted By</span>,
    selector: 'submittedBy',
    sortable: true,
    cell: row => {
      let firstName = '',
        middleName = '',
        lastName = '';
      if (_.get(row, 'submittedBy.firstName', false))
        firstName = _.get(row, 'submittedBy.firstName', '');
      if (_.get(row, 'submittedBy.middleName', false))
        middleName = _.get(row, 'submittedBy.middleName', '');
      if (_.get(row, 'submittedBy.lastName', false))
        lastName = _.get(row, 'submittedBy.lastName', '');
      return (
        <div className={`${commonRowStyle}`}>
          {`${firstName} ${middleName} ${lastName}`}
        </div>
      );
    }
  },
  {
    name: <span className={`${commonStyle}`}>Assign To CM</span>,
    selector: 'cmName',
    sortable: true,
    cell: row => {
      let CMFirstName = '',
        CMMdName = '',
        CMlstName = '';

      const [showReassign, setShowReassign] = useState(false);
      const [showCMName, setCMName] = useState(
        `${CMFirstName} ${CMMdName} ${CMlstName}`
      );
      const [showNotAllowed, setShowNotAllowed] = useState(false);
      const isAthorisedToReassign = getAcl()?.acl?.can_reassign_leads;
      const handleClick = () => {
        setShowReassign(true);
        setShowNotAllowed(true);
      };
      useEffect(() => {
        if (typeof row?.cmName?.firstName == 'string')
          CMFirstName = row.cmName.firstName;
        if (typeof row?.cmName?.middleName == 'string')
          CMMdName = row.cmName.middleName;
        if (typeof row?.cmName?.lastName == 'string')
          CMlstName = row.cmName.lastName;
        setCMName(`${CMFirstName} ${CMMdName} ${CMlstName}`);
      }, [row?.cmId]);

      return (
        <div
          className={`${commonRowStyle} ${
            isAthorisedToReassign ? 'cursor-pointer ' : ''
          }`}
          onClick={() => (isAthorisedToReassign ? handleClick() : null)}
        >
          {showReassign ? (
            <ShowAssignModal
              row={row}
              setShowReassign={setShowReassign}
              setCMName={setCMName}
              showCMName={showCMName}
            />
          ) : null}
          <p className="text-green-900 font-medium cursor-pointer">
            {showCMName ? `${showCMName}` : <span>&#8212; </span>}
          </p>
        </div>
      );
    }
  },
  {
    name: (
      <span className={`${commonStyle} text-right mr-0`}>Sanction Amount</span>
    ),
    selector: 'finalSanctionAmount',
    sortable: true,
    cell: row => (
      <div className={`${commonRowStyle} text-right mr-0`}>
        {row.finalSanctionAmount ? (
          <span> &#8377;{` ${numberFormat(row.finalSanctionAmount)}`}</span>
        ) : (
          '---'
        )}
      </div>
    )
  },
  {
    name: (
      <span className={`${commonStyle} text-right mr-0`}>Disbursed Amount</span>
    ),
    selector: 'disbursedAmount',
    sortable: true,
    cell: row => (
      <div className={`${commonRowStyle} text-right mr-0`}>
        {row.disbursedAmount ? (
          <span> &#8377;{` ${numberFormat(row.disbursedAmount)}`}</span>
        ) : (
          '---'
        )}
      </div>
    )
  },

  {
    name: <span className={`${commonStyle} `}>Status</span>,
    selector: 'status',
    sortable: true,
    cell: row => {
      let specificStyles, InfoText;
      if (row.status == 'In Principle Pending')
        (specificStyles = 'text-orange-1000 bg-orange-fade'),
          (InfoText = 'In-Principal sanction Pending');
      else if (row.status == 'In Principle Rejected')
        (specificStyles = 'text-red-400 bg-red-600'),
          (InfoText = 'In-Principal sanction Rejected');
      else if (row.status == 'In Principle Accepted')
        (specificStyles = 'text-green-1200 bg-green-fade'),
          (InfoText = 'In Principle sanction Accepted');
      else if (row.status == 'Login')
        (specificStyles = 'text-orange-600 bg-orange-50'), (InfoText = 'Login');
      else if (row.status == 'Sanctioned')
        (specificStyles = 'text-green-600 bg-green-100'),
          (InfoText = 'Final Sanction');
      else if (row.status == 'Disbursed')
        (specificStyles = 'text-green-600 bg-green-200'),
          (InfoText = 'Disbursed');
      else
        (specificStyles = 'text-orange-600 bg-orange-50'),
          (InfoText = row.status);
      return (
        <div
          className={`${commonRowStyle} ${specificStyles} px-2 py-1 font-medium rounded `}
          style={{ minWidth: '80%' }}
        >
          {InfoText ? InfoText : '---'}
        </div>
      );
    },
    minWidth: '190px !important'
  },

  {
    name: <span className={`${commonStyle} `}>CAM Status</span>,
    selector: 'camStatus',
    sortable: false,
    cell: row => {
      let specificStyles = '';
      if (row.camStatus == 'Uploaded') {
        specificStyles = 'text-green-600';
      } else if (row.camStatus == 'Approved') {
        specificStyles = 'text-green-1200';
      } else if (row.camStatus == 'Rejected') {
        specificStyles = 'text-red-400';
      } else {
        specificStyles = '';
      }

      return (
        <div
          className={`${commonRowStyle} ${specificStyles} px-2 py-1 font-medium rounded `}
          style={{ minWidth: '80%' }}
        >
          {row?.camStatus ? row?.camStatus : '---'}
        </div>
      );
    },
    minWidth: '190px !important'
  },

  {
    name: <span className={`${commonStyle}`}>TAT</span>,
    selector: 'tat',
    sortable: true,
    cell: row => <div className={`${commonRowStyle}`}>{getTime(row.tat)}</div>
  },
  {
    name: <span className={`${commonStyle}`}>Action</span>,
    selector: 'action',
    sortable: false,
    cell: row => (
      <div
        className={`w-40 font-roboto font-normal text-sm mx-auto  bg-blue-1101 text-white py-2 px-5 rounded cursor-pointer `}
        onClick={() =>
          openDetailView(setDetailView, row.leadId, row.status, row.loanAmount)
        }
      >
        View
      </div>
    )
  }
];

export default CMColumn;
